import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { ComponentHelper } from "../core/util/componentHelper";
import { DropDownList } from "../core/components/dropDownList";
import { Helper } from "../core/util/helper";
import React from "react";
export class IndividualFieldDropDown extends React.Component<IndividualFieldDropDownProps, IndividualFieldDropDownState>{
    private factory = ComponentHelper.createFactory();
    private saveId: string = "EditIndividualFieldsDropDown";
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            data: []
        }
        this.initApp();

    }

    private initApp = async () => {
        const result = await HTTPService.get<JsonResultClass<[]>>(this.props.url);
        this.setState({ data: result.Data });
    }

    private createDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.state.data;
        props.value = this.state.value;//Helper.loadDataFromStorage(this.saveId);
        props.field.dataTextField = "TableName";
        props.field.dataValueField = "TableName";
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:300px'><colgroup><col style='width: 150px' /><col style='width: 150px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'> ${data.TableName}</td><td style='vertical-align:top'> (${data.EntityType})</td></tr></table>";
        props.field.refreshDSOnRefChange = true;
        props.onChange = (_, value) => {
            Helper.saveDataToStorage(this.saveId, value, false);
            this.setState({ value: value }, () => {
                this.props.onSelectChange(value);
            });
        }
        return (
            <div style={{ margin: "15px", marginTop: "0" }}>
                <DropDownList {...props} />
            </div>
        );
    }

    componentWillUnmount() {
        Helper.removeDataFromStorage(this.saveId);
    }

    render() {
        return (
            <>
                <div style={{ margin: "15px" }}>
                    <span style={{ fontSize: "x-large" }}>
                        {this.props.translations["Field.SatzSperre.tabname"]}
                    </span>
                </div>
                {this.createDropDown()}
            </>
        );
    }

}

export interface IndividualFieldDropDownProps {
    url: string;
    onSelectChange: (tableName: string) => void
    translations: {}
}

interface IndividualFieldDropDownState {
    value: string;
    data: {
        TableName: string
    }[]
}